module.exports = __webpack_public_path__ + "img/five-3.58a07ba5.png";